<template>
    <div class="stamp-shop-detail">
        <div class="good-bg">
            <img v-if="commodityPicUrl" class="good-icon" :src="commodityPicUrl" alt="商品图片" />
            <div class="good-info">
                <div class="title">{{ name }}</div>
                <div v-if="time" class="time">{{time}}</div>
                <div class="number">数量x1</div>
                <div class="point"><span style="font-size: 20px; margin-right: 5px;">{{ point }}</span>印花</div>
            </div>
            <div class="exchange-tag" :style="{ background: color }">{{ exchangeType }}</div>
        </div>

        <div v-if="point < 0" class="point-bg">
            <div class="point-item">
                <div class="title">印花数量</div>
                <div class="value">{{ point }}</div>
            </div>
            <div class="point-item" style="border-bottom: none;">
                <div class="title">兑换数量</div>
                <div class="value">{{ quantity }}</div>
            </div>
        </div>

        <div style="height: 150px; width: 100%"></div>

        <div v-if="isUnUsed" class="exchange-bg" :class="{ 'exchange-bg-use': isStampExchange && isUnUsed }">
            <button class="exchange-btn" @click="useBtn">去使用</button>
        </div>
        <div v-if="isStampExchange && isUnUsed" class="exchange-bg">
            <button class="exchange-btn" @click="exchangeBtn">取消兑换</button>
        </div>

        <el-dialog v-if="show" :title="title" :visible.sync="show" width="80%">
            <div class="message">确定取消兑换吗？</div>
            <div class="dialog-buttons">
                <button class="tip-cancel" @click="cancel">取消</button>
                <button class="tip-ok" @click="submit">确认</button>
            </div>
        </el-dialog>
        <!-- Toast 提示 -->
        <Toast ref="toast"></Toast>
    </div>
</template>

<script>
import { getVoucher, voucherCancel, getExchangeLog } from '@/api/StampShop'
import {BASE_URL} from "@/config/app";
import {parseTime} from "@/unitls";

export default {
    name: 'StampShopDetail',
    data() {
        return {
            id: '',
            type: '',
            title: '兑换成功',
            name: '',
            time: '',
            show: false,
            point: '',
            quantity: '',
            color: '',
            commodityPicUrl: '',
            exchangeType: '',
            isVoucher: false,
            isStampExchange: false,
            isUnUsed: false
        }
    },
    created() {
        this.id = this.$route.query.id
        this.type = this.$route.query.type
        this.isVoucher = this.type === 'voucher'
        this.loadDetail()
    },
    methods: {
        // Toast 提示方法
        toast(e) {
            this.$refs.toast.show(e, 1500);
        },
        async loadDetail() {
            try {
                if (this.isVoucher) {
                    const res = await getVoucher({ id: this.id })

                    if (res.code === this.$API_CODE.OK) {
                        this.name = res.data.duiName
                        this.point = res.data.usedStampNumber
                        this.quantity = 1
                        this.exchangeType = res.data.activityName
                        this.color = res.data.activityColor
                        this.commodityPicUrl = BASE_URL + res.data.duiImgUrl
                        this.isUnUsed = res.data.status === 0
                        this.isStampExchange = res.data.activityType === 0
                        this.time = parseTime(res.data.exchangeTime, '{y}-{m}-{d} {h}:{i}') + ' ~ ' + parseTime(res.data.expirationTime, '{y}-{m}-{d} {h}:{i}')
                    } else {
                        this.toast(res.message)
                    }
                } else {
                    const res = await getExchangeLog({ id: this.id })

                    if (res.code === this.$API_CODE.OK) {
                        this.name = res.data.name
                        this.point = res.data.stampNumber
                        this.quantity = 1
                        this.exchangeType = res.data.activityName
                        this.color = res.data.activityColor
                        this.commodityPicUrl = res.data.imgUrl ? BASE_URL + res.data.imgUrl : ''
                    } else {
                        this.toast(res.message)
                    }
                }
            } catch (error) {
                console.error('加载详情失败:', error)
            }
        },

        exchangeBtn() {
            this.show = true
        },

        async submit() {
            try {
                const res = await voucherCancel({ id: this.id })

                if (res.code === this.$API_CODE.OK) {
                    this.$router.push('/exchangeRecord')
                } else {
                    this.toast(res.message)
                }
            } catch (error) {
                console.error('取消兑换失败:', error)
            }
            this.show = false
        },

        cancel() {
            this.show = false
        },

        useBtn() {
            this.$router.push({
                path: '/placeOrder',
                query: { type: '0' }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.stamp-shop-detail {
    background-color: #f7f7f7;
    min-height: 100vh;
    padding-bottom: 20px;
}

.good-bg {
    width: 92%;
    margin: 12px auto;
    padding: 15px;
    background: #ffffff;
    border-radius: 15px;
    height: 116px;
    position: relative;
}

.good-icon {
    width: 86px;
    height: 86px;
    float: left;
    object-fit: contain;
}

.good-info {
    height: 86px;
    float: left;
    width: 63%;
    margin-left: 15px;
}

.good-info .title {
    text-align: left;
    color: #666666;
    font-size: 15px;
    height: 25px;
}

.good-info .time {
    text-align: left;
    color: #999999;
    font-size: 12px;
    height: 40px;
}

.good-info .number {
    float: left;
    color: #999999;
    font-size: 12px;
}

.good-info .point {
    float: right;
    color: #d33a35;
    font-size: 12px;
}

.exchange-tag {
    position: absolute;
    top: 0;
    right: 0;
    color: #ffffff;
    font-size: 12px;
    padding: 4px 12px;
    border-radius: 0 15px 0 12px;
    line-height: 1.5;
}

.point-bg {
    width: 92%;
    margin: 12px auto;
    padding: 15px;
    background: #ffffff;
    border-radius: 15px;
}

.point-item {
    color: #333333;
    font-size: 15px;
    border-bottom: 1px solid #dbdbdb;
    height: 40px;
    line-height: 40px;
}

.point-item .title {
    float: left;
}

.point-item .value {
    float: right;
}

.exchange-bg {
    width: 90%;
    position: fixed;
    left: 5%;
    right: 5%;
    bottom: 20px;
    z-index: 999;
}

.exchange-bg-use {
    bottom: 80px;
}

.exchange-btn {
    background: #d33a35;
    border-radius: 25px;
    width: 100%;
    height: 50px;
    line-height: 50px;
    padding: 0;
    color: #ffffff;
    font-size: 20px;
    border: none;
    cursor: pointer;

    &:active {
        opacity: 0.8;
    }
}

.message {
    font-size: 16px;
    color: #333;
    text-align: center;
    margin-bottom: 20px;
    font-weight: 500;
}

.dialog-buttons {
    display: flex;
    justify-content: space-around;
    margin-top: 15px;
    gap: 10px;
}

.tip-cancel,
.tip-ok {
    flex: 1;
    color: #ffffff;
    font-size: 15px;
    font-weight: 500;
    border-radius: 5px;
    border: none;
    padding: 10px 0;
    cursor: pointer;

    &:active {
        opacity: 0.8;
    }
}

.tip-cancel {
    background: linear-gradient(135deg, #409eff, #66b1ff);
    box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
}

.tip-ok {
    background: linear-gradient(135deg, #ea2d53, #f56c6c);
    box-shadow: 0 2px 6px rgba(234, 45, 83, 0.3);
}
</style>
